const zhCN = {
  warningTypeTxt: '预警类型',
  option_allType: '全部',

  startTimeTxt: '开始时间',
  endTimeTxt: '结束时间',
  aWeekBeforeBtn: '前一周',
  oneMonthBeforeBtn: '前一个月',
  threeMonthsBeforeBtn: '前三个月',

  deviceSNOrNameTxt: '设备SN/设备名称',
  searchBtn: '搜索',

  listWarningType: '预警类型',
  listDeviceSN: '设备SN',
  listDeviceName: '设备名称',
  listSitePhotos: '现场照',
  listBlacklistPhoto: '黑名单人脸照',
  listBlacklistRemark: '黑名单备注',
  listWarningTime: '预警时间',

  getRecordsFail: '获取预警记录失败！',

  sitePhotoModalTitle: '现场照片'
}
const enUS = {
  warningTypeTxt: 'Warning Type',
  option_allType: 'All',
  
  startTimeTxt: 'Start Time',
  endTimeTxt: 'End Time',
  aWeekBeforeBtn: 'a week before',
  oneMonthBeforeBtn: 'one month before',
  threeMonthsBeforeBtn: 'three months before',
  
  deviceSNOrNameTxt: 'Device SN / Name',
  searchBtn: 'Search',

  listWarningType: 'Warning Type',
  listDeviceSN: 'Device SN',
  listDeviceName: 'Device Name',
  listSitePhotos: 'Site Photos',
  listBlacklistPhoto: 'Blacklist Photo',
  listBlacklistRemark: 'Blacklist Remark',
  listWarningTime: 'Warning Time',

  getRecordsFail: 'Get warning records failed!',

  sitePhotoModalTitle: 'Site Photo'
}

export default { zhCN, enUS }